import {ModifiersEnum} from './searchModifiersHelpers';
import {isSearchModifierToken, splitSearchQuery} from './searchQueryHelpers';

/*
 * Helpers.
 */

export function parseAccountFilter(searchQuery: string): string | undefined {
  const queryParts = splitSearchQuery(searchQuery);

  // Find the first query part for `account`, if it exists.
  const firstAccountPart = queryParts.find(
    (part) =>
      part.token && isSearchModifierToken(part.token) && part.token.modifier === ModifiersEnum.ACCOUNT,
  );

  if (!firstAccountPart) {
    return undefined;
  }

  return firstAccountPart.token?.value;
}

export function hasTagFilter(searchQuery: string): boolean {
  const queryParts = splitSearchQuery(searchQuery);

  return queryParts.some(
    (part) => part.token && isSearchModifierToken(part.token) && part.token.modifier === ModifiersEnum.TAG,
  );
}

export function hasAssigneeFilter(searchQuery: string): boolean {
  const queryParts = splitSearchQuery(searchQuery);

  return queryParts.some(
    (part) =>
      part.token && isSearchModifierToken(part.token) && part.token.modifier === ModifiersEnum.ASSIGNEE,
  );
}
